module.exports = __webpack_public_path__ + "media/images/responsive/articles/logo_aqua-47c388ad16fbaa7dacc4b4e3dfa1360e.svg";